import { Box, Button } from '@mui/material';
import Dialog from 'components/dialog';
import GoogleMaps from 'components/google-maps/google-maps';
import InfoBox from 'components/info-box';
import TextField from 'components/text-field';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SiteMarker from 'views/overview/components/site-marker';
import { useCalibrationState } from '../../../context/calibration-context';

type Props = {
  location: {
    latitude: number | null;
    longitude: number | null;
  };
};

const ViewLocation: React.FC<Props> = ({ location }) => {
  const intl = useIntl();

  const PAGE_NAME_ID = `bluViuNutrition.calibrations.editCalibration.temperatureLocation.location`;

  const {
    simpleCalibrationQuery: { data: calibration },
  } = useCalibrationState();

  if (!location) return;

  return (
    <Dialog
      title={intl.formatMessage({ id: `${PAGE_NAME_ID}.title` })}
      button={
        <Button>
          <FormattedMessage id={`${PAGE_NAME_ID}.dialogButton`} />
        </Button>
      }
      maxWidth={'md'}>
      <Box display={'flex'} flexDirection={'column'} gap={4}>
        <Box pb={4} sx={{ height: { xs: '400px', md: '400px' } }}>
          <GoogleMaps
            editLocation={true}
            center={{
              lat: Number(location.latitude) || 0,
              lng: Number(location.longitude) || 0,
            }}>
            <SiteMarker
              marker={{
                lat: Number(location.latitude) || 0,
                lng: Number(location.longitude) || 0,
                name: calibration?.name,
              }}
            />
          </GoogleMaps>
        </Box>
        <Box display={'flex'} flexDirection={'row'} gap={4}>
          <TextField
            type="number"
            disabled
            decimalScale={14}
            dark
            fullWidth
            label={intl.formatMessage({ id: `${PAGE_NAME_ID}.latitude` })}
            value={location.latitude}
          />
          <TextField
            type="number"
            disabled
            decimalScale={14}
            dark
            fullWidth
            label={intl.formatMessage({ id: `${PAGE_NAME_ID}.longitude` })}
            value={location.longitude}
          />
        </Box>
        <InfoBox>
          <FormattedMessage id={`${PAGE_NAME_ID}.information`} />
        </InfoBox>
      </Box>
    </Dialog>
  );
};

export default React.memo(ViewLocation);
